import { httpService } from '../../../../services/http.service';
import { BASE_URL, USER } from '../../../../constants/endpoints';
import bugsnagHandler from '../../../../services/bugsnag.service';

const { CONTROLLERS: { CANCEL_INVOICE: { BASE, VERSION } } } = USER;

export const markAsCanceledAPIAction = async (customerId: string, externalId: string) => {
  if (!customerId || !externalId) {
    bugsnagHandler.notify('Invoice Hub - Mark as Cancel Action - Missing customerId or externalId');
    return false;
  }
  try {
    const { data } = await httpService.post(`${BASE_URL}/api/${VERSION}/${BASE}/${customerId}/invoice/${externalId}/markAsCancel`);
    return data;
  } catch (e: any) {
    bugsnagHandler.notify('Invoice Hub - Mark as Cancel Action - error cancelling an invoice', e);
    throw e;
  }
};
